import { render, staticRenderFns } from "./InactiveUser.vue?vue&type=template&id=af3b7d4a&scoped=true"
import script from "./InactiveUser.vue?vue&type=script&lang=js"
export * from "./InactiveUser.vue?vue&type=script&lang=js"
import style0 from "./InactiveUser.vue?vue&type=style&index=0&id=af3b7d4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af3b7d4a",
  null
  
)

export default component.exports